import { render, staticRenderFns } from "./SSelectorMultiple.vue?vue&type=template&id=0bd5511e&scoped=true"
import script from "./sSelectorMultiple.ts?vue&type=script&lang=ts&external"
export * from "./sSelectorMultiple.ts?vue&type=script&lang=ts&external"
import style0 from "./SSelectorMultiple.vue?vue&type=style&index=0&id=0bd5511e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5511e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd5511e')) {
      api.createRecord('0bd5511e', component.options)
    } else {
      api.reload('0bd5511e', component.options)
    }
    module.hot.accept("./SSelectorMultiple.vue?vue&type=template&id=0bd5511e&scoped=true", function () {
      api.rerender('0bd5511e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-selector-multiple/SSelectorMultiple.vue"
export default component.exports